var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      staticClass: "mx-3 mt-2",
      model: {
        value: _vm.searchParamsValid,
        callback: function($$v) {
          _vm.searchParamsValid = $$v
        },
        expression: "searchParamsValid"
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Tilaustunnus",
                  clearable: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.updatedSearchParams.orderId,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "orderId", $$v)
                  },
                  expression: "updatedSearchParams.orderId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "6" } },
            [
              _c("v-autocomplete", {
                attrs: { items: _vm.regions, label: this.$t("invoicing.area") },
                model: {
                  value: _vm.updatedSearchParams.cardNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "cardNumber", $$v)
                  },
                  expression: "updatedSearchParams.cardNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "6" } },
            [
              _c("EventTypeField", {
                attrs: {
                  updatedSearchParams: _vm.updatedSearchParams.eventTypes
                },
                on: {
                  "update:updatedSearchParams": function(newValues) {
                    return (_vm.updatedSearchParams.eventTypes = newValues)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-3", attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "7" } },
            [
              _c("ValidationStatesField", {
                attrs: {
                  validationStates: _vm.updatedSearchParams.validationStates
                },
                on: {
                  "update:validationStates": function(newValues) {
                    return (_vm.updatedSearchParams.validationStates = newValues)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "3" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "pt-0",
                  attrs: { outlined: "", small: "" },
                  on: { click: _vm.setFailedValidations }
                },
                [_vm._v(" Search failed validations ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-slide-y-transition",
        [
          _vm.updatedSearchParams.validationStates.includes(
            _vm.validationStatusTypes.ExternalValidationFailed
          ) &&
          (_vm.updatedSearchParams.validationStates.length === 1 ||
            (_vm.updatedSearchParams.validationStates.length === 2 &&
              _vm.updatedSearchParams.validationStates.includes(
                _vm.validationStatusTypes.InternalValidationFailed
              )))
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 py-0",
                      attrs: { cols: "12", sm: "7" }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: Object.keys(_vm.likumaValidationErrors),
                          label: "Likuma error types",
                          multiple: "",
                          clearable: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("v-chip", [
                                    _vm._v(
                                      " " +
                                        _vm._s(item) +
                                        " - " +
                                        _vm._s(
                                          _vm.likumaValidationErrors[item]
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "item",
                              fn: function(ref) {
                                var item = ref.item
                                var attrs = ref.attrs
                                var on = ref.on
                                return [
                                  _c(
                                    "v-list-item",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var active = ref.active
                                                  return [
                                                    _c(
                                                      "v-list-item-content",
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                attrs: {
                                                                  "no-gutters":
                                                                    "",
                                                                  align:
                                                                    "center"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item
                                                                    ) +
                                                                    " - " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .likumaValidationErrors[
                                                                        item
                                                                      ]
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item-action",
                                                      [
                                                        _c("v-checkbox", {
                                                          attrs: {
                                                            "input-value": active
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        "v-list-item",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1315076683
                        ),
                        model: {
                          value:
                            _vm.updatedSearchParams.validationFailReasonCodes,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.updatedSearchParams,
                              "validationFailReasonCodes",
                              $$v
                            )
                          },
                          expression:
                            "updatedSearchParams.validationFailReasonCodes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm.updatedSearchParams.validationStates.length === 1 &&
              _vm.updatedSearchParams.validationStates.includes(
                _vm.validationStatusTypes.New
              )
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 py-0",
                      attrs: { cols: "12", md: "9" }
                    },
                    [
                      _c(
                        "v-item-group",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c("v-item", {
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var active = ref.active
                                          var toggle = ref.toggle
                                          return [
                                            _c("v-checkbox", {
                                              attrs: {
                                                value: (_vm.updatedSearchParams.missingTrip = active),
                                                label: "Trip missing",
                                                ripple: false
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return toggle($event)
                                                }
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                [
                                  _c("v-item", {
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var active = ref.active
                                          var toggle = ref.toggle
                                          return [
                                            _c("v-checkbox", {
                                              attrs: {
                                                value: (_vm.updatedSearchParams.missingCharge = active),
                                                label: "Charge missing",
                                                ripple: false
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return toggle($event)
                                                }
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c("v-spacer")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "6" } },
            [
              _c("SalesInvoiceStatesField", {
                attrs: {
                  updatedSearchParams:
                    _vm.updatedSearchParams.salesInvoiceStates,
                  disabled: !!_vm.updatedSearchParams.salesInvoiceNumbers
                },
                on: {
                  "update:updatedSearchParams": function(newValues) {
                    return (_vm.updatedSearchParams.salesInvoiceStates = newValues)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", sm: "1" } },
            [_c("v-subheader", [_vm._v("OR")])],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "5" } },
            [
              _c("v-text-field", {
                attrs: { label: "Sales invoice number" },
                on: {
                  change: function($event) {
                    _vm.updatedSearchParams.salesInvoiceStates = []
                  }
                },
                model: {
                  value: _vm.updatedSearchParams.salesInvoiceNumbers,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.updatedSearchParams,
                      "salesInvoiceNumbers",
                      $$v
                    )
                  },
                  expression: "updatedSearchParams.salesInvoiceNumbers"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "6" } },
            [
              _c("PurchaseInvoiceStatesField", {
                attrs: {
                  updatedSearchParams:
                    _vm.updatedSearchParams.purchaseInvoiceStates,
                  disabled: !!_vm.updatedSearchParams.purchaseInvoiceNumbers
                },
                on: {
                  "update:updatedSearchParams": function(newValues) {
                    return (_vm.updatedSearchParams.purchaseInvoiceStates = newValues)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", sm: "1" } },
            [_c("v-subheader", [_vm._v("OR")])],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "5" } },
            [
              _c("v-text-field", {
                attrs: { label: "Purchase invoice number" },
                on: {
                  change: function($event) {
                    _vm.updatedSearchParams.purchaseInvoiceStates = []
                  }
                },
                model: {
                  value: _vm.updatedSearchParams.purchaseInvoiceNumbers,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.updatedSearchParams,
                      "purchaseInvoiceNumbers",
                      $$v
                    )
                  },
                  expression: "updatedSearchParams.purchaseInvoiceNumbers"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Vehicle id" },
                model: {
                  value: _vm.updatedSearchParams.carNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "carNumber", $$v)
                  },
                  expression: "updatedSearchParams.carNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Service number" },
                model: {
                  value: _vm.updatedSearchParams.serviceNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "serviceNumber", $$v)
                  },
                  expression: "updatedSearchParams.serviceNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Card number" },
                model: {
                  value: _vm.updatedSearchParams.cardNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "cardNumber", $$v)
                  },
                  expression: "updatedSearchParams.cardNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "4" } },
            [
              _c("PaymentMethodField", {
                attrs: {
                  updatedSearchParams: _vm.updatedSearchParams.paymentMethods
                },
                on: {
                  "update:updatedSearchParams": function(newValues) {
                    return (_vm.updatedSearchParams.paymentMethods = newValues)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Asiakkuusnumero" },
                model: {
                  value: _vm.updatedSearchParams.costCenter,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "costCenter", $$v)
                  },
                  expression: "updatedSearchParams.costCenter"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "2" } },
            [_vm._v("Modified")]
          ),
          _c(
            "v-col",
            {
              staticClass: "pl-0 py-0",
              attrs: { cols: "12", sm: "6", md: "3" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Modified from",
                  type: "date",
                  max: "2099-12-31"
                },
                model: {
                  value: _vm.updatedSearchParams.modifiedFrom,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "modifiedFrom", $$v)
                  },
                  expression: "updatedSearchParams.modifiedFrom"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pl-0 py-0",
              attrs: { cols: "12", sm: "6", md: "3" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Modified to",
                  type: "date",
                  max: "2099-12-31"
                },
                model: {
                  value: _vm.updatedSearchParams.modifiedTo,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "modifiedTo", $$v)
                  },
                  expression: "updatedSearchParams.modifiedTo"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "2" } },
            [_vm._v("Trip started")]
          ),
          _c(
            "v-col",
            {
              staticClass: "pl-0 py-0",
              attrs: { cols: "12", sm: "6", md: "3" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Trip started from",
                  type: "date",
                  max: "2099-12-31"
                },
                model: {
                  value: _vm.updatedSearchParams.tripStartedFrom,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "tripStartedFrom", $$v)
                  },
                  expression: "updatedSearchParams.tripStartedFrom"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pl-0 py-0",
              attrs: { cols: "12", sm: "6", md: "3" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Trip started to",
                  type: "date",
                  max: "2099-12-31"
                },
                model: {
                  value: _vm.updatedSearchParams.tripStartedTo,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "tripStartedTo", $$v)
                  },
                  expression: "updatedSearchParams.tripStartedTo"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "2" } },
            [_vm._v("Trip ended")]
          ),
          _c(
            "v-col",
            {
              staticClass: "pl-0 py-0",
              attrs: { cols: "12", sm: "6", md: "3" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Trip ended from",
                  type: "date",
                  max: "2099-12-31"
                },
                model: {
                  value: _vm.updatedSearchParams.tripEndedFrom,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "tripEndedFrom", $$v)
                  },
                  expression: "updatedSearchParams.tripEndedFrom"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pl-0 py-0",
              attrs: { cols: "12", sm: "6", md: "3" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Trip ended to",
                  type: "date",
                  max: "2099-12-31"
                },
                model: {
                  value: _vm.updatedSearchParams.tripEndedTo,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "tripEndedTo", $$v)
                  },
                  expression: "updatedSearchParams.tripEndedTo"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0 mb-2", attrs: { cols: "12", md: "2" } },
            [_vm._v("Kustannus")]
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
            [
              _c("v-text-field", {
                staticClass: "pt-0 centered-input",
                staticStyle: { width: "70px" },
                attrs: {
                  "single-line": "",
                  type: "number",
                  placeholder: "-",
                  variant: "outlined",
                  dense: ""
                },
                model: {
                  value: _vm.updatedSearchParams.costFrom,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "costFrom", $$v)
                  },
                  expression: "updatedSearchParams.costFrom"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "hidden-xs-only py-0 pb-3",
              staticStyle: { "font-size": "1.5em" },
              attrs: { sm: "auto" }
            },
            [_vm._v(" - ")]
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
            [
              _c("v-text-field", {
                staticClass: "pt-0 centered-input",
                staticStyle: { width: "70px" },
                attrs: {
                  "single-line": "",
                  type: "number",
                  placeholder: "-",
                  variant: "outlined",
                  dense: ""
                },
                model: {
                  value: _vm.updatedSearchParams.costTo,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "costTo", $$v)
                  },
                  expression: "updatedSearchParams.costTo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function($event) {
                      _vm.updatedSearchParams.costFrom = null
                      _vm.updatedSearchParams.costTo = null
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.clear")))]
              )
            ],
            1
          ),
          _c("v-spacer")
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0 mb-2", attrs: { cols: "12", md: "2" } },
            [_vm._v("Korvaus")]
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
            [
              _c("v-text-field", {
                staticClass: "pt-0 centered-input",
                staticStyle: { width: "70px" },
                attrs: {
                  "single-line": "",
                  type: "number",
                  placeholder: "-",
                  variant: "outlined",
                  dense: ""
                },
                model: {
                  value: _vm.updatedSearchParams.reimbursementFrom,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "reimbursementFrom", $$v)
                  },
                  expression: "updatedSearchParams.reimbursementFrom"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "hidden-xs-only py-0 pb-3",
              staticStyle: { "font-size": "1.5em" },
              attrs: { sm: "auto" }
            },
            [_vm._v(" - ")]
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
            [
              _c("v-text-field", {
                staticClass: "pt-0 centered-input",
                staticStyle: { width: "70px" },
                attrs: {
                  "single-line": "",
                  type: "number",
                  placeholder: "-",
                  variant: "outlined",
                  dense: ""
                },
                model: {
                  value: _vm.updatedSearchParams.reimbursementTo,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "reimbursementTo", $$v)
                  },
                  expression: "updatedSearchParams.reimbursementTo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function($event) {
                      _vm.updatedSearchParams.reimbursementFrom = null
                      _vm.updatedSearchParams.reimbursementTo = null
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.clear")))]
              )
            ],
            1
          ),
          _c("v-spacer")
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0 mb-2", attrs: { cols: "12", md: "2" } },
            [_vm._v("Omavastuu")]
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
            [
              _c("v-text-field", {
                staticClass: "pt-0 centered-input",
                staticStyle: { width: "70px" },
                attrs: {
                  "single-line": "",
                  type: "number",
                  placeholder: "-",
                  variant: "outlined",
                  dense: ""
                },
                model: {
                  value: _vm.updatedSearchParams.deductibleFrom,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "deductibleFrom", $$v)
                  },
                  expression: "updatedSearchParams.deductibleFrom"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "hidden-xs-only py-0 pb-3",
              staticStyle: { "font-size": "1.5em" },
              attrs: { sm: "auto" }
            },
            [_vm._v(" - ")]
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
            [
              _c("v-text-field", {
                staticClass: "pt-0 centered-input",
                staticStyle: { width: "70px" },
                attrs: {
                  "single-line": "",
                  type: "number",
                  placeholder: "-",
                  variant: "outlined",
                  dense: ""
                },
                model: {
                  value: _vm.updatedSearchParams.deductibleTo,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "deductibleTo", $$v)
                  },
                  expression: "updatedSearchParams.deductibleTo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function($event) {
                      _vm.updatedSearchParams.deductibleFrom = null
                      _vm.updatedSearchParams.deductibleTo = null
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.clear")))]
              )
            ],
            1
          ),
          _c("v-spacer")
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c("v-switch", {
            attrs: { label: "Etsi myös poistettuja tapahtumia" },
            model: {
              value: _vm.updatedSearchParams.removed,
              callback: function($$v) {
                _vm.$set(_vm.updatedSearchParams, "removed", $$v)
              },
              expression: "updatedSearchParams.removed"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }